// action/graph.js
import { authorizedUser } from "components/CommonFunctions";
import * as api from "../API/index";

export const GetGraphData = async (filter) => {
  try {
    const res = await api.get_graph_data(filter);
    return res.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    throw error;
  }
};
